// Full Service constants shared by the pages and the server (no server-only
// imports here — the order form and the choice page bundle this file).
// See lib/full_service.js for the order storage and the sales email.

export const FULL_SERVICE_PRICE = "$39.99";
export const COMPOSITOR_PRICE   = "$9.99";
export const FULL_SERVICE_SALES_EMAIL = "sales@recruitgraphics.com";

export const MAX_SUBJECT_IMAGES = 3;
export const MAX_EXAMPLE_IMAGES = 5;
export const MAX_IMAGE_BYTES    = 25 * 1024 * 1024;

export const ORDER_KEY_PROP = "_full_service_order_key";

// Where "Compositor" continues for each entry — what /start/<entry> went to
// before the choice page existed.
export const COMPOSITOR_DEST = {
  announcement: "/templates?flow=announcement",
  print:        "/print/style",
};

export const IMAGE_TYPES = {
  "image/jpeg": "jpg",
  "image/png":  "png",
  "image/webp": "webp",
  "image/heic": "heic",
  "image/heif": "heif",
};

// The Information Collection fields per flow, mirroring app/announcement and
// app/print/composite/info. `optional` fields have an N/A checkbox there.
export const INFO_FIELDS = {
  announcement: [
    { key: "announcementType", label: "Announcement Type" },
    { key: "firstName",        label: "First Name" },
    { key: "lastName",         label: "Last Name" },
    { key: "school",           label: "School / Organization" },
    { key: "sport",            label: "Sport / Activity / Discipline", optional: true },
    { key: "primaryColor",     label: "Primary School / Organization Color" },
    { key: "secondaryColor",   label: "Secondary School / Organization Color" },
  ],
  print: [
    { key: "firstName",        label: "First Name" },
    { key: "lastName",         label: "Last Name" },
    { key: "number",           label: "Jersey Number", optional: true },
    { key: "school",           label: "School / Organization" },
    { key: "sport",            label: "Sport / Activity / Discipline", optional: true },
    { key: "title",            label: "Mascot / Position / Nickname / Adjective" },
    { key: "primaryColor",     label: "Primary School / Organization Color" },
    { key: "secondaryColor",   label: "Secondary School / Organization Color" },
    { key: "productColor",     label: "Product Color" },
  ],
};

// What the admin's "Message" box starts with on an order.
export const DEFAULT_DELIVERY_MESSAGE = "Thank you for your order. Here are your download link(s):";
